import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../Components/Layout';

import BannerCarousel from '../Components/BannerCarousel';
import ActiveSweepstakes from '../Components/Sweepstakes/ActiveSweepstakes';
import ExpiredSweepstakes from '../Components/Sweepstakes/ExpiredSweepstakes';

import '../Components/Sweepstakes/style.scss';

const PromotionsPage = ({ user, config, cmsSourceFirebase, actions, match }) => {
    useEffect(() => {
        actions.sweepActions.getSweeps();
    }, [actions]);
    return (
        <Layout {...{ user, config, cmsSourceFirebase, actions, match }}>
            <div className='promotions-container'>
                <BannerCarousel name='ctl_promo_page_carousel' />
                <ActiveSweepstakes title='Current Promotions' variant='theme-purple' />
                <ExpiredSweepstakes title='Past Promotions' variant='theme-purple' />
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionsPage);
